import DocsConfig from '@tencent/docs-config';
const appConfigInstance = DocsConfig.getInstance();
const npmConfig = appConfigInstance.getConfig('npm["@tencent/docs-design-resources"]')
let p = (!!npmConfig && npmConfig.CDN_ORIGIN) || 'https://docs.gtimg.com/docs-design-resources';
p = p + '/cooperation/ai/template/template_ppt_techno_silky_yellow/'
export function getTemplateThumbnail1() { return p+'template_thumbnail_1-7927093bbc.png'; };
export function getTemplateThumbnail10() { return p+'template_thumbnail_10-accccbb0f1.png'; };
export function getTemplateThumbnail2() { return p+'template_thumbnail_2-9325be5b57.png'; };
export function getTemplateThumbnail3() { return p+'template_thumbnail_3-21a208fa19.png'; };
export function getTemplateThumbnail4() { return p+'template_thumbnail_4-53a43fceb9.png'; };
export function getTemplateThumbnail5() { return p+'template_thumbnail_5-8fa52330d3.png'; };
export function getTemplateThumbnail6() { return p+'template_thumbnail_6-eaae3dce69.png'; };
export function getTemplateThumbnail7() { return p+'template_thumbnail_7-23649f97e9.png'; };
export function getTemplateThumbnail8() { return p+'template_thumbnail_8-e6f69efbee.png'; };
export function getTemplateThumbnail9() { return p+'template_thumbnail_9-cb3388c129.png'; };
